<template>
  <div>
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        <IconMoreOptionComponent size="small" theme="blue" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <!-- 1. Ver -->
        <el-dropdown-item command="remission-view">
          <i class="el-icon-view"></i> Ver
        </el-dropdown-item>

        <!-- 2. Enviar documento -->
        <el-dropdown-item command="remission-send">
          <i class="el-icon-s-promotion"></i> Enviar documento
        </el-dropdown-item>

        <!-- Firmar -->
        <template
          v-if="
            status === 'draft' || status === 'failed' || status === 'timeout'
          "
        >
          <el-dropdown-item command="remission-signature">
            <i class="el-icon-edit-outline"></i> Firmar
          </el-dropdown-item>
        </template>

        <!-- Editar -->
        <template v-if="status === 'draft' || status === 'failed'">
          <el-dropdown-item command="remission-edit">
            <i class="el-icon-edit"></i> Editar
          </el-dropdown-item>
        </template>

        <!-- Descargar PDF -->
        <el-dropdown-item command="remission-download">
          <i class="el-icon-download"></i> Descargar PDF
        </el-dropdown-item>

        <!-- Anular -->
        <template v-if="status === 'success'">
          <el-dropdown-item command="remission-nuled">
            <i class="el-icon-circle-close"></i> Anular
          </el-dropdown-item>
        </template>

        <!-- Eliminar (siempre al final) -->
        <template v-if="status === 'draft' || status === 'failed'">
          <el-dropdown-item command="remission-delete" divided>
            <i class="el-icon-delete"></i> Eliminar
          </el-dropdown-item>
        </template>
      </el-dropdown-menu>
    </el-dropdown>

    <!-- Firmar modal -->
    <SigningConfirmModal
      :visible.sync="sriModalVisible"
      :documentNumber="remission ? remission.number_remission : ''"
      :clientName="remission ? remission.destination_name || '' : ''"
      :amount="0"
      @confirm="sendSRI"
    />

    <!-- Anular modal -->
    <el-dialog
      title=""
      :visible.sync="nuledModalVisible"
      append-to-body
      custom-class="confirm-modal"
    >
      <div class="text-center">
        <img :src="icoNotifyDanger" alt="" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea anular la guía de remisión?
        </h4>
        <p class="text-color-primary">
          Para completar el proceso, anúlela también en el <LinkSRI />
        </p>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="nuledModalVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent title="Anular" @onSaveClick="onNuled" />
        </div>
      </div>
    </el-dialog>

    <!-- Eliminar modal -->
    <el-dialog
      title=""
      :visible.sync="deleteModalVisible"
      append-to-body
      custom-class="confirm-modal"
    >
      <div class="text-center">
        <img :src="icoNotifyDanger" alt="" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea eliminar esta guía de remisión?
        </h4>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="deleteModalVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent title="Eliminar" @onSaveClick="onDelete" />
        </div>
      </div>
    </el-dialog>

    <WrapperSendDocumentDrawer
      @onDocumentSend="onDocumentSend"
      @onCloseDrawer="visibleDocumentSend = false"
      :visibleDocumentSend="visibleDocumentSend"
      :toMails="toMails"
      :toPhone="''"
      :recipientName="remission ? remission.destination_name || '' : ''"
      :messageableType="'remission'"
      :messageableId="id"
      :moduleType="'remission'"
      :draftKey="'draft-remission-' + id"
    />
  </div>
</template>

<script>
import WrapperSendDocumentDrawer from "../../../../components/WrapperSendDocumentDrawer";
import remissionService from "../services/remissionService";
import { downloadFile } from "@/assets/utils/files";
import IconMoreOptionComponent from "@/components/General/IconMoreOption";
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import LinkSRI from "@/components/General/LinkSRI";
import SigningConfirmModal from "@/components/General/SigningConfirmModal";
import { signingEventBus } from "@/services/signingEventBus";
import {
  icoNotifyDanger,
  iconEdit,
  iconDelete,
  iconNuled,
  iconSend,
  icoSignature,
  icoPreview
} from "@/services/resources";

export default {
  name: "RemissionOptionsByStatus",
  props: ["status", "id"],
  data() {
    return {
      icoNotifyDanger,
      iconEdit,
      iconDelete,
      iconNuled,
      iconSend,
      icoSignature,
      icoPreview,
      sriModalVisible: false,
      nuledModalVisible: false,
      deleteModalVisible: false,
      visibleDocumentSend: false,
      remission: null,
      toMails: []
    };
  },
  methods: {
    async getRemission() {
      try {
        const r = await remissionService.getRemissionById(this.id);
        if (r) this.remission = r.data.data;
      } catch (e) {
        return false;
      }
    },
    async handleCommand(command) {
      if (!this.remission) {
        await this.getRemission();
        await this.$nextTick();
      }
      switch (command) {
        case "remission-view":
          this.$emit("goPage", "sales.remissions.view", { id: this.id });
          break;
        case "remission-edit":
          this.$emit("goPage", "sales.remissions.edit", { id: this.id });
          break;
        case "remission-signature":
          this.sriModalVisible = true;
          break;
        case "remission-nuled":
          this.nuledModalVisible = true;
          break;
        case "remission-delete":
          this.deleteModalVisible = true;
          break;
        case "remission-download":
          this.download();
          break;
        case "remission-send":
          this.toMails =
            this.remission && this.remission.email
              ? [this.remission.email]
              : [];
          this.visibleDocumentSend = true;
          break;
      }
    },
    async download() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const { number_remission, id } = this.remission;
        let response = await remissionService
          .remissionDownload({ id })
          .finally(() => this.$store.dispatch("toggleRequestLoading"));
        if (response.data)
          downloadFile(response.data, `GuiaRemision - #${number_remission}`);
      } catch (e) {
        return false;
      }
    },
    async sendSRI() {
      const docId = this.remission.id;
      const documentNumber = `GR #${this.remission.number_remission}`;
      const clientName = this.remission.destination_name || "";

      this.sriModalVisible = false;
      signingEventBus.$emit("signing:start", {
        id: docId,
        clientName,
        documentNumber
      });
      this.$emit("onSigningStart", docId);

      try {
        const r = await remissionService.sendRemissionSRI({
          user_business_remission_id: docId
        });
        const { success, message, data } = r.data;
        if (success) {
          signingEventBus.$emit("signing:done", {
            id: docId,
            clientName,
            documentNumber
          });
          this.remission = data;
          this.$emit("onSigningDone", { id: docId, data });
        } else {
          signingEventBus.$emit("signing:error", {
            id: docId,
            message: message || "Error al firmar"
          });
          this.$emit("onSigningError", docId);
        }
      } catch (error) {
        signingEventBus.$emit("signing:error", {
          id: docId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al firmar"
        });
        this.$emit("onSigningError", docId);
      }
    },
    async onNuled() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const docId = this.remission.id;
        const r = await remissionService
          .updateRemissionStatus({ user_business_remission_id: docId })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.nuledModalVisible = false;
          });
        const { success, message, data } = r.data;
        if (success) {
          this.remission = data;
          this.$notifications.success({ message });
          this.$emit("onSigningDone", { id: docId, data });
        }
      } catch (e) {
        return false;
      }
    },
    async onDelete() {
      try {
        const docId = this.remission.id;
        const r = await remissionService
          .deleteRemissionById(docId)
          .finally(() => {
            this.deleteModalVisible = false;
          });
        const { success, message } = r.data;
        if (success) {
          this.$notifications.success({ message });
          this.$emit("onDocDeleted", docId);
        }
      } catch (e) {
        return false;
      }
    },
    async onDocumentSend({ data }) {
      this.$store.dispatch("toggleRequestLoading");
      try {
        data.append("remission_id", this.remission.id);
        const r = await remissionService
          .sendRemissionEmail({ data })
          .finally(() => this.$store.dispatch("toggleRequestLoading"));
        const { success, message } = r.data;
        if (success) {
          this.visibleDocumentSend = false;
          this.$notifications.success({ message });
        }
      } catch (e) {
        return false;
      }
    }
  },
  components: {
    IconMoreOptionComponent,
    ButtonPrimaryComponent,
    WrapperSendDocumentDrawer,
    LinkSRI,
    SigningConfirmModal
  }
};
</script>
